/**
 * MoozState header surface controller
 *
 * Transparent while scrolling down (and at page top).
 * Solid white while scrolling up, or on desktop hover.
 * Does not use :focus-within (theme editor selection was locking the bar white).
 */
(function () {
  const HEADER_SEL = '#header-component';
  const TOP_THRESHOLD = 8;
  const DIR_THRESHOLD = 2;

  /** @type {HTMLElement | null} */
  let header = null;
  let hovering = false;
  let raf = 0;
  let lastY = 0;
  /** @type {'none' | 'up' | 'down'} */
  let direction = 'none';

  function finePointer() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function scrollY() {
    return window.scrollY || document.documentElement.scrollTop || 0;
  }

  function apply() {
    if (!header) return;

    const y = scrollY();
    const atTop = y <= TOP_THRESHOLD;
    const delta = y - lastY;

    if (atTop) {
      direction = 'none';
    } else if (delta < -DIR_THRESHOLD) {
      direction = 'up';
    } else if (delta > DIR_THRESHOLD) {
      direction = 'down';
    }

    // White: hover OR scrolling up. Transparent: at top OR scrolling down.
    const solid = hovering || direction === 'up';

    header.setAttribute('data-ms-solid', solid ? 'true' : 'false');
    header.setAttribute('data-scroll-direction', direction);

    // Always use the drawer hamburger — never the desktop link menu.
    header.dataset.menuStyle = 'drawer';

    lastY = y;
  }

  function onScroll() {
    if (raf) return;
    raf = window.requestAnimationFrame(() => {
      raf = 0;
      apply();
    });
  }

  function onEnter() {
    if (!finePointer()) return;
    hovering = true;
    apply();
  }

  function onLeave() {
    if (!hovering) return;
    hovering = false;
    apply();
  }

  function unbind() {
    window.removeEventListener('scroll', onScroll);
    if (header) {
      header.removeEventListener('mouseenter', onEnter);
      header.removeEventListener('mouseleave', onLeave);
    }
  }

  function bind(el) {
    unbind();
    header = el;
    lastY = scrollY();
    direction = 'none';
    hovering = false;
    apply();
    window.addEventListener('scroll', onScroll, { passive: true });
    el.addEventListener('mouseenter', onEnter);
    el.addEventListener('mouseleave', onLeave);
  }

  function init() {
    const el = document.querySelector(HEADER_SEL);
    if (el instanceof HTMLElement) bind(el);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
